import { DesignBoardType } from "../../../__generated__/types";

export const designBoardInputRules: Record<DesignBoardType, string[]> = {
  [DesignBoardType.Color]: ["color"],
  [DesignBoardType.Mood]: ["roomType"],
  [DesignBoardType.PatternPlay]: ["pattern", "color"],
  [DesignBoardType.StyleFusion]: ["pattern", "color"],
  [DesignBoardType.TextureAndFinish]: ["texture", "finish"],
};
